<template>
  <div v-if="dialogPrint" style="display: none"></div>
</template>
<script>
import { getLodop } from "@/plugins/data/LodopFuncs";
import {
  PRINT_SCENES,
  resolvePrintTemplate,
  resolvePrintTemplateWithOverride,
} from "@/unit/printTemplateStorage.js";
import {
  renderWashNative,
  renderAnnexNative,
  mapStoreWashPayload,
  resolveStoreWashGrillObj,
} from "@/unit/printLodopNative.js";

export default {
  props: {
    parentCode: {
      type: Object,
      default: () => ({}),
    },
    printBy: {
      type: String,
      default: "",
    },
    isWash: {
      type: Boolean,
      default: false,
    },
    grillObj: {
      type: Object,
      default: () => ({}),
    },
    templateOverride: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      printName: this.printBy,
      annexData: this.parentCode,
      dialogPrint: this.isWash,
      grillObjs: this.grillObj,
      time: `${new Date().getMonth() + 1}/${new Date().getDate()}`,
    };
  },
  watch: {
    parentCode(newVal) {
      this.annexData = newVal;
    },
    printBy(newVal) {
      this.printName = newVal;
    },
    isWash(newVal) {
      this.dialogPrint = newVal;
    },
    grillObj(newVal) {
      this.grillObjs = newVal;
    },
  },
  mounted() {
    this.$emit("washed-code", this.parentCode);
  },
  methods: {
    getTemplate() {
      if (this.templateOverride) {
        return resolvePrintTemplateWithOverride(
          PRINT_SCENES.STORE_WASH,
          this.templateOverride,
        );
      }
      return resolvePrintTemplate(PRINT_SCENES.STORE_WASH);
    },
    runWashLodop(annexData, preview) {
      const printName = annexData.printName || this.printName;
      if (!annexData || !annexData.washingCode || !printName) {
        return false;
      }
      const LODOP = getLodop();
      if (!LODOP) {
        return false;
      }
      const tpl = this.getTemplate();
      const data = {
        ...annexData,
        time: this.time,
      };
      const payload = mapStoreWashPayload(
        data,
        tpl,
        resolveStoreWashGrillObj(data, this.grillObjs),
      );
      LODOP.PRINT_INIT("水洗码" + annexData.washingCode);
      renderWashNative(LODOP, tpl, payload, {
        code: annexData.washingCode,
        printName,
        scene: PRINT_SCENES.STORE_WASH,
      });
      if (preview) {
        LODOP.PREVIEW();
      } else {
        LODOP.PRINT();
      }
      return true;
    },
    printWashCode(printData) {
      if (printData) {
        this.annexData = printData;
      }
      const data = printData || this.annexData;
      data.printName = data.printName || this.printName;
      this.runWashLodop(data, false);
    },
    previewWashCode(printData) {
      if (printData) {
        this.annexData = printData;
      }
      const data = { ...(printData || this.annexData) };
      data.printName = data.printName || this.printName || -1;
      return this.runWashLodop(data, true);
    },
  },
};
</script>
